import keyMirror from 'keymirror'
import {
  CommonPriceList,
  CommonProduct,
} from 'payment-common/src/vtj/price-list.type'

export const CertificateProductType = keyMirror({
  ASUINPAIKKATODISTUS_SAHKOINEN: null,
  ELOSSAOLOTODISTUS_SAHKOINEN: null,
  AVIOLIITTOTODISTUS_SAHKOINEN: null,
  SIVIILISAATYTODISTUS_SAHKOINEN: null,
  SYNTYMATODISTUS_SAHKOINEN: null,
  ASUINPAIKKATODISTUS_EU_VIRANOMAISELLE: null,
  ELOSSAOLOTODISTUS_EU_VIRANOMAISELLE: null,
  AVIOLIITTOTODISTUS_EU_VIRANOMAISELLE: null,
  SIVIILISAATYTODISTUS_EU_VIRANOMAISELLE: null,
  SYNTYMATODISTUS_EU_VIRANOMAISELLE: null,
  ASUINPAIKKATODISTUS_EU_VIRANOMAISELLE_KAANNOSLOMAKKEELLA: null,
  ELOSSAOLOTODISTUS_EU_VIRANOMAISELLE_KAANNOSLOMAKKEELLA: null,
  AVIOLIITTOTODISTUS_EU_VIRANOMAISELLE_KAANNOSLOMAKKEELLA: null,
  SIVIILISAATYTODISTUS_EU_VIRANOMAISELLE_KAANNOSLOMAKKEELLA: null,
  SYNTYMATODISTUS_EU_VIRANOMAISELLE_KAANNOSLOMAKKEELLA: null,
  ASUINPAIKKATODISTUS_APOSTILLE: null,
  ELOSSAOLOTODISTUS_APOSTILLE: null,
  AVIOLIITTOTODISTUS_APOSTILLE: null,
  SIVIILISAATYTODISTUS_APOSTILLE: null,
  SYNTYMATODISTUS_APOSTILLE: null,
  ASUINPAIKKATODISTUS_ELOMAKE: null,
  ELOSSAOLOTODISTUS_ELOMAKE: null,
  AVIOLIITTOTODISTUS_ELOMAKE: null,
  SIVIILISAATYTODISTUS_ELOMAKE: null,
  SYNTYMATODISTUS_ELOMAKE: null,
  AETTODISTUS: null,
  UAETTODISTUS: null,
  TODISTUSASUMISTIEDOILLA_ELOMAKE: null,
  TODISTUSHENKILOJAPERHESUHDETIEDOILLA_ELOMAKE: null,
  TODISTUSKUOLEMASTA_ELOMAKE: null,
  MUU_MANUAALINEN_TODISTUS_ELOMAKE: null,
  EU_MONIKIELINEN_VAKIOLOMAKE: null,
  APOSTILLE_TODISTUS: null,
})

export type CertificateProductTypeId =
  (typeof CertificateProductType)[keyof typeof CertificateProductType]

export type TodistusProduct = CommonProduct<CertificateProductTypeId>

export type TodistuksetPriceList = CommonPriceList<TodistusProduct>
